/* Lab401: Accessibility enhancements
 *
 * 1. High-contrast mode — wires every [data-hc-toggle] button to the
 *    html.lab401-hc class. The class itself is applied pre-paint by an inline
 *    script in theme.liquid (localStorage 'lab401-hc', or prefers-contrast).
 * 2. Scrollable regions — horizontally scrollable tables/grids (chipset
 *    comparison tables in product descriptions, advantages grids) are not
 *    keyboard-reachable by default (WCAG 2.1.1). Give them tabindex so
 *    keyboard users can focus and arrow-scroll them.
 * 3. Iframe titles — media embeds in article/page content often ship without
 *    a title attribute (WCAG 4.1.2). Best-effort naming by source.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  var labels = script.dataset;
  var scrollableLabel = labels.scrollableLabel;

  /* ---- 1. High-contrast toggle ---------------------------------------- */

  var HC_CLASS = 'lab401-hc';
  var HC_KEY = 'lab401-hc';
  var root = document.documentElement;

  function hcSyncButtons() {
    var on = root.classList.contains(HC_CLASS);
    document.querySelectorAll('[data-hc-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hc-toggle]');
    if (!btn) return;
    var on = !root.classList.contains(HC_CLASS);
    root.classList.toggle(HC_CLASS, on);
    try {
      localStorage.setItem(HC_KEY, on ? '1' : '0');
    } catch (err) {
      /* private mode — mode still applies for this page view */
    }
    hcSyncButtons();
  });

  /* ---- 2. Scrollable regions ------------------------------------------ */

  function enhanceScrollableRegions() {
    var candidates = document.querySelectorAll(
      '#site-main table, #site-main .advantages-grid'
    );
    candidates.forEach(function (el) {
      var cs = getComputedStyle(el);
      var scrolls =
        (cs.overflowX === 'auto' || cs.overflowX === 'scroll' || cs.overflow === 'auto') &&
        el.scrollWidth > el.clientWidth + 1;

      if (!scrolls) return;
      if (el.hasAttribute('data-a11y-scroll-done')) return;
      el.setAttribute('data-a11y-scroll-done', '');
      el.setAttribute('tabindex', '0');

      /* Tables keep native table semantics — tabindex alone makes the
         scroll container reachable. Non-table containers get a region role
         so the focus stop is announced meaningfully. */
      if (el.tagName !== 'TABLE' && !el.getAttribute('role')) {
        el.setAttribute('role', 'region');
        if (!el.getAttribute('aria-label')) {
          el.setAttribute('aria-label', scrollableLabel);
        }
      }
    });
  }

  /* ---- 3. Iframe titles ------------------------------------------------ */

  function titleForIframe(src) {
    if (/youtube|youtu\.be/i.test(src)) return labels.youtubePlayer;
    if (/vimeo/i.test(src)) return labels.vimeoPlayer;
    if (/maps\.google|google\.[a-z.]+\/maps/i.test(src)) return labels.map;
    return labels.embeddedContent;
  }

  function enhanceIframes() {
    document.querySelectorAll('iframe:not([title])').forEach(function (frame) {
      frame.setAttribute('title', titleForIframe(frame.src || ''));
    });
  }

  function run() {
    hcSyncButtons();
    enhanceScrollableRegions();
    enhanceIframes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Late-loading embeds and layout shifts: one delayed pass + resize re-check */
  window.addEventListener('load', function () {
    setTimeout(run, 1500);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(enhanceScrollableRegions, 250);
  });
})();
